import type { IconData } from '@stacksjs/iconify-core'

export const mg1x1: IconData = {
  "body": "<g fill-rule=\"evenodd\" stroke-width=\"1pt\"><path fill=\"#fc3d32\" d=\"M170.7 0H512v256H170.7z\"/><path fill=\"#007e3a\" d=\"M170.7 256H512v256H170.7z\"/><path fill=\"#fff\" d=\"M0 0h170.7v512H0z\"/></g>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default mg1x1
